import Services from './services'

export default {
  name: 'tickets',
  mixins: [Services],
  data: () => ({
    is_ticket: false,
    tickets: [],
    noAllStores: true,
  }),
  methods: {
    add_ticket() {
      if (this.tickets.length == 0 || this.tickets[this.tickets.length - 1].value !== null)
        this.tickets.push({name: null})
    },
    remove_ticket(index) {
      this.tickets.splice(index, 1)
    },
    tickets_cancel() {
      this.is_ticket = this.computed_tickets['is_ticket']
      this.tickets = this.$copy(this.computed_tickets['tickets'])
    },
    async tickets_save() {
      var tickets = []
      for (const index in this.tickets) {
        tickets.push({name: this.tickets[index].name})
      }
      await this.$communicator('update_tickets', {
        params: {
          service: this.store?._id,
          tickets: tickets
        }
      })
      this.update_tickets()
    },
    async update_tickets() {
      if (this.stores.length > 0 && this.store == null) {
        this.store = this.stores[0]
      }
      if (this.store) {
        const tickets = this.$communicator.then(this, await this.$communicator('tickets', {
          params: {
            service: this.store?._id
          }
        }))
        if (tickets) {
          this.tickets = []
          for (const ticket in tickets) {
            this.tickets.push({name: tickets[ticket].name})
          }
          this.$store.commit('tickets', {
            is_ticket: this.is_ticket,
            tickets: this.tickets
          })
        }
      }
    }
  },
  computed: {
    computed_tickets() {
      return this.$store.state.tickets
    }
  },
  mounted() {
    this.tickets_cancel()
    this.update_tickets()
  },
  watch: {
    stores: {
      deep: true, handler() {
        this.update_tickets()
      }
    },
    store() {
      this.update_tickets()
    }
  }
}
